import React from 'react'
import './styles.css'
import PlanBox from '~/components/PlanBox'
import Spinner from '~/components/Spinner'
import { getSubscriptionPlans, getInvisiblePlans } from '~/redux/user/subscription'
import popup from '~/views/Popup/popup'
import { trackEvent } from '~/tools/analytics/cleverTap'
import connect from "~/tools/connect";
import userStore from '~/redux/user/store';


class SelectPlans02 extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      plans: [],
      selected: null,
      loading: true
    }
  }

  componentDidMount() {
    if(this.state.user && this.state.user.isSubscribed){
      window.location.href = '/'
      return false
    }
    if(!window.sessionStorage.getItem('plans')){  
      getSubscriptionPlans().then( plans => {
        this.setState({ 'plans': plans, loading: false })
      })
    } else {
      getInvisiblePlans().then( plans => {
        this.setState({ 'plans': plans, loading: false })
      })
    }
    trackEvent('View Plans', { source: 'Web' })
  }

  selectPlan(id) {
    return popup.createSubscription(id)
  }

  render() {

    return(
      <div className="select-plans02-container">
        { this.state.user && this.state.user.isSubscribed ? (
          <div className="thank-you"> Thank you for subscribing! </div>
        ) : (
          <div className="select-plans02">
            <p className="choose-plan-text">{this.props.data && this.props.data.title}</p>
            <p className="introductory-desc">{this.props.data && this.props.data.description}</p>
            { this.state.loading && <Spinner/> }
            <div className="landing-page-plans site-color">
              {
                this.state.plans.map( (data, i) => {
                  return (
                    <PlanBox
                      plan={ data }
                      key={ data.id }
                      onClick={ _ => this.selectPlan(data.id) }
                      />
                  )
                })
              }
            </div>
          </div>
          ) }
      </div>
    )
  }
}

connect(SelectPlans02, (state) => ({ user: state.user }), userStore)

export default SelectPlans02
